/* ========================================
   vc.js – VapeChamp Custom JavaScript
   Horizon v3.0 – Upgrade-Safe
   ======================================== */

/* ========================================
   1. CART TOOLTIP SYSTEM
   ======================================== */

const CartTooltip = (() => {
  let previousCartCount = 0;
  let hideTooltipTimeout = null;

  function ensureTooltipOnTop() {
    const cartTooltipWrapper = document.getElementById('vc-cart-tooltip-wrapper');
    if (!cartTooltipWrapper) return;

    // Check if modal is open - if so, move tooltip INTO modal
    const openModal = document.querySelector('dialog.dialog-modal[open]');

    if (openModal) {
      // Move into modal so it's in the Top Layer
      if (cartTooltipWrapper.parentElement !== openModal) {
        openModal.appendChild(cartTooltipWrapper);
      }
    } else {
      // No modal, keep in body
      if (cartTooltipWrapper.parentElement !== document.body) {
        document.body.appendChild(cartTooltipWrapper);
      }
    }
  }

  function positionTooltip() {
    const cartIconButton = document.querySelector('.header-actions__action[aria-label*="Warenkorb"], .header-actions__action[on\\:click*="cart"]');
    const cartTooltipWrapper = document.getElementById('vc-cart-tooltip-wrapper');

    if (!cartIconButton || !cartTooltipWrapper) return;

    // Get cart icon position
    const iconRect = cartIconButton.getBoundingClientRect();

    // Calculate position: below icon, aligned to icon center
    let top = iconRect.bottom + 10;
    const iconCenterX = iconRect.left + (iconRect.width / 2);

    // Pointer is 21px from right edge of tooltip (14px + 7px)
    let right = window.innerWidth - iconCenterX - 21;

    // If tooltip is inside a modal, compensate for modal's position and use absolute positioning
    const openModal = document.querySelector('dialog.dialog-modal[open]');
    const isInModal = openModal && cartTooltipWrapper.parentElement === openModal;

    if (isInModal) {
      const modalRect = openModal.getBoundingClientRect();
      // Compensate for modal's top offset
      top = top - modalRect.top;
      // Compensate for modal's left offset (convert viewport right to modal right)
      right = (window.innerWidth - modalRect.left) - iconCenterX - 21;
      cartTooltipWrapper.style.position = 'absolute';
    } else {
      cartTooltipWrapper.style.position = 'fixed';
    }

    // Set position directly on wrapper
    cartTooltipWrapper.style.top = top + 'px';
    cartTooltipWrapper.style.right = right + 'px';
    cartTooltipWrapper.style.left = 'auto';
    cartTooltipWrapper.style.bottom = 'auto';
    cartTooltipWrapper.style.margin = '0';
  }

  function showTooltip() {
    let cartTooltipWrapper = document.getElementById('vc-cart-tooltip-wrapper');
    if (!cartTooltipWrapper) return;

    // Clear any existing timeout
    if (hideTooltipTimeout) {
      clearTimeout(hideTooltipTimeout);
      hideTooltipTimeout = null;
    }

    // Hide if already visible
    cartTooltipWrapper.classList.remove('vc-tooltip-visible');

    setTimeout(() => {
      // Move tooltip into modal if one is open (to be in Top Layer)
      ensureTooltipOnTop();

      // IMPORTANT: Re-fetch element after ensureTooltipOnTop() because Shopify might have replaced it
      cartTooltipWrapper = document.getElementById('vc-cart-tooltip-wrapper');
      if (!cartTooltipWrapper) return;

      // Show and position
      cartTooltipWrapper.classList.add('vc-tooltip-visible');
      positionTooltip();

      // Set new timeout and store the ID
      hideTooltipTimeout = setTimeout(() => {
        // Hide ALL tooltip elements (in case Shopify created duplicates during re-renders)
        let hiddenCount = 0;
        let attempt = 0;
        const maxAttempts = 10; // Reduced from 50 to 10 (500ms max instead of 2.5s)

        // Keep trying to hide tooltips until none are visible
        const hideInterval = setInterval(() => {
          attempt++;

          // Find ALL elements with this ID (even though ID should be unique)
          const allTooltips = document.querySelectorAll('#vc-cart-tooltip-wrapper, .vc-cart-tooltip-wrapper');
          let foundVisible = false;

          allTooltips.forEach((wrapper) => {
            if (wrapper.offsetHeight > 0 || wrapper.classList.contains('vc-tooltip-visible') || wrapper.style.display === 'block') {
              wrapper.classList.remove('vc-tooltip-visible');
              wrapper.style.display = 'none';
              hiddenCount++;
              foundVisible = true;
            }
          });

          // Stop if no more visible tooltips or max attempts reached
          if (!foundVisible || attempt >= maxAttempts) {
            clearInterval(hideInterval);
            hideTooltipTimeout = null;
          }
        }, 50); // Check every 50ms
      }, 2500);
    }, 10);
  }

  function animateCartBubble() {
    const cartBubble = document.querySelector('.cart-bubble');
    if (!cartBubble) return;

    cartBubble.classList.remove('vc-cart-pop');
    void cartBubble.offsetWidth;
    cartBubble.classList.add('vc-cart-pop');

    setTimeout(() => {
      cartBubble.classList.remove('vc-cart-pop');
    }, 600);
  }

  function handleCartCountChange(currentCartCount) {
    animateCartBubble();

    // VC 04.10.2026: Hinweis kommt jetzt über den Warenkorb-Toast (AddToCartToast)
    if (previousCartCount === 0 && currentCartCount > 0 && !window.VCAddToCartToast) {
      showTooltip();
    }

    previousCartCount = currentCartCount;
  }

  function initObserver() {
    const cartBubbleCount = document.querySelector('.cart-bubble__text-count');

    if (!cartBubbleCount) {
      setTimeout(initObserver, 100);
      return;
    }

    previousCartCount = parseInt(cartBubbleCount.textContent, 10) || 0;

    const observer = new MutationObserver(() => {
      const currentCartCount = parseInt(cartBubbleCount.textContent, 10) || 0;
      handleCartCountChange(currentCartCount);
    });

    observer.observe(cartBubbleCount, {
      characterData: true,
      childList: true,
      subtree: true
    });

    // Reposition tooltip on window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const cartTooltipWrapper = document.getElementById('vc-cart-tooltip-wrapper');
        if (cartTooltipWrapper && cartTooltipWrapper.style.display === 'block') {
          positionTooltip();
        }
      }, 100);
    });
  }

  return {
    init: initObserver
  };
})();


/* ========================================
   2. MODAL CUSTOMIZATION SYSTEM
   ======================================== */

const ModalCustomization = (() => {
  function createCloseButton() {
    const closeButton = document.createElement('button');
    closeButton.className = 'vc-modal-close-button';
    closeButton.innerHTML = `
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 10l5 5 5-5z"/>
      </svg>
      <span>Schließen</span>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 10l5 5 5-5z"/>
      </svg>
    `;
    return closeButton;
  }

  function addCloseButton(modal) {
    if (modal.querySelector('.vc-modal-close-button')) return;

    const closeButton = createCloseButton();
    closeButton.addEventListener('click', () => {
      const originalCloseButton = modal.querySelector('.quick-add-modal__close');
      if (originalCloseButton) {
        originalCloseButton.click();
      }
    });

    modal.appendChild(closeButton);
  }

  function addProductInfoIcon(modal) {
    const productTitleLink = modal.querySelector('.view-product-title a, .product-header a');
    if (!productTitleLink || productTitleLink.parentNode.querySelector('.vc-product-info-wrapper')) return;

    const productUrl = productTitleLink.getAttribute('href');
    if (!productUrl) return;

    const parentContainer = productTitleLink.parentNode;

    const iconWrapper = document.createElement('div');
    iconWrapper.className = 'vc-product-info-wrapper';

    const infoIcon = document.createElement('a');
    infoIcon.className = 'vc-product-info-icon';
    infoIcon.href = productUrl;
    infoIcon.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke-width="1.5"/>
        <path d="M12 17V11" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)"/>
      </svg>
    `;
    iconWrapper.appendChild(infoIcon);

    const titleWrapper = document.createElement('div');
    titleWrapper.className = 'vc-product-title-wrapper';
    titleWrapper.appendChild(productTitleLink);

    parentContainer.insertBefore(iconWrapper, parentContainer.firstChild);
    parentContainer.insertBefore(titleWrapper, parentContainer.firstChild);
  }

  function addFootnote(modal) {
    if (modal.querySelector('.vc-modal-footnote')) return;

    const footnote = document.createElement('div');
    footnote.className = 'vc-modal-footnote';
    footnote.innerHTML = `
      <p>* Alle Preise inkl. gesetzlicher Steuern, zzgl. <a href="/pages/versandbedingungen">Versandkosten</a>.</p>
    `;

    // Try desktop: In .group-block-content einfügen
    const groupBlockContent = modal.querySelector('.quick-add-modal__content .group-block .group-block-content');
    if (groupBlockContent) {
      groupBlockContent.appendChild(footnote);
      return;
    }

    // Fallback: Direkt in modal content als letztes Element
    const modalContent = modal.querySelector('.quick-add-modal__content');
    if (modalContent) {
      modalContent.appendChild(footnote);
    }
  }

  function waitForModalContent(modal, callback, attempts = 0, maxAttempts = 40) {
    const priceElement = modal.querySelector('.quick-add-modal__content product-price');
    const productForm = modal.querySelector('product-form-component');
    const productDetails = modal.querySelector('.product-details');

    // For delivery status we only need priceElement and productForm
    // productDetails is optional (doesn't exist on mobile)
    if (priceElement && productForm) {
      callback();
      return;
    }

    if (attempts < maxAttempts) {
      setTimeout(() => waitForModalContent(modal, callback, attempts + 1, maxAttempts), 50);
    }
  }

  function customize() {
    const modal = document.querySelector('.quick-add-modal');
    if (!modal) return;

    addCloseButton(modal);

    setTimeout(() => {
      waitForModalContent(modal, () => {
        // Call product functions from window.VCProducts if available
        if (window.VCProducts) {
          window.VCProducts.DeliveryStatus.add(modal);
          window.VCProducts.PaymentButton.customize();
        }
        addFootnote(modal);
        addProductInfoIcon(modal);
      });
    }, 100);
  }

  function initObserver() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && node.classList && node.classList.contains('quick-add-modal')) {
              if (node.hasAttribute('open')) {
                customize();
              }
            }
          });
        }

        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const modal = mutation.target;
          if (modal.classList.contains('quick-add-modal') && modal.hasAttribute('open')) {
            customize();
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open']
    });
  }

  return {
    initObserver
  };
})();


/* ========================================
   3. COLLECTION PAGE ROW GRADIENTS
   ======================================== */

const CollectionRowGradients = (() => {
  function createGradients() {
    // Entferne alte Gradienten
    document.querySelectorAll('.vc-row-gradient').forEach(el => el.remove());

    const grid = document.querySelector('.product-grid');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.product-grid__item'));
    if (items.length === 0) return;

    const fullWidthContainer = document.body;
    fullWidthContainer.style.position = 'relative';

    // Gruppiere Items nach Zeilen (basierend auf offsetTop)
    const rows = [];
    let currentRow = [];
    let lastTop = null;

    items.forEach(item => {
      const top = item.offsetTop;

      if (lastTop === null || Math.abs(top - lastTop) < 5) {
        currentRow.push(item);
      } else {
        if (currentRow.length > 0) {
          rows.push(currentRow);
        }
        currentRow = [item];
      }
      lastTop = top;
    });

    if (currentRow.length > 0) {
      rows.push(currentRow);
    }

    // Erstelle Gradient für jede Zeile
    rows.forEach((rowItems) => {
      const firstItem = rowItems[0];
      const firstCardGallery = firstItem.querySelector('.card-gallery');

      if (!firstCardGallery) return;

      let maxImageHeight = 0;
      let maxTextHeight = 0;

      rowItems.forEach(item => {
        const cardGallery = item.querySelector('.card-gallery');

        if (cardGallery) {
          maxImageHeight = Math.max(maxImageHeight, cardGallery.offsetHeight);
        }

        const textBlock = item.querySelector('.text-block');
        const priceBlock = item.querySelector('product-price');

        if (textBlock && priceBlock) {
          const textHeight = textBlock.offsetHeight + priceBlock.offsetHeight;
          maxTextHeight = Math.max(maxTextHeight, textHeight);
        }
      });

      const galleryRect = firstCardGallery.getBoundingClientRect();
      const gradientTop = galleryRect.bottom + window.scrollY;

      const gradientDiv = document.createElement('div');
      gradientDiv.className = 'vc-row-gradient';
      gradientDiv.style.cssText = `
        position: absolute;
        left: 0;
        width: 100%;
        top: ${gradientTop}px;
        height: ${maxTextHeight + 30}px;
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(230, 230, 230, 1) 100%);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        border-bottom: 1px solid rgba(210, 210, 210, 1);
        pointer-events: none;
        z-index: -1;
      `;

      fullWidthContainer.appendChild(gradientDiv);
    });

    items.forEach(item => {
      item.style.position = 'relative';
      item.style.zIndex = '1';
    });
  }

  function initObservers() {
    // Bei Window Resize
    window.addEventListener('resize', () => {
      requestAnimationFrame(createGradients);
    });

    // Bei Shopify Section Events
    document.addEventListener('shopify:section:load', createGradients);
    document.addEventListener('shopify:section:reorder', createGradients);

    // Bei dynamischen Inhalten (Pagination, Filter)
    const grid = document.querySelector('.product-grid');
    if (grid) {
      const observer = new MutationObserver(() => {
        createGradients();
      });

      observer.observe(grid, { childList: true, subtree: true });
    }
  }

  function init() {
    if (document.readyState !== 'loading') {
      createGradients();
    }

    document.addEventListener('DOMContentLoaded', () => {
      createGradients();
      initObservers();
    });

    window.addEventListener('load', createGradients, { once: true });
  }

  return {
    init
  };
})();


/* ========================================
   4. CART RECOMMENDATIONS SYSTEM
   ======================================== */

const CartRecommendations = (() => {
  let isUpdatingRecommendation = false;
  let lastRecommendedProductId = null; // Track last recommended product

  async function fetchRecommendations(productId, limit = 10) {
    try {
      const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}`);
      if (!response.ok) return null;
      const data = await response.json();
      return data.products || [];
    } catch (error) {
      console.error('Recommendations fetch error:', error);
      return null;
    }
  }

  function escapeHTML(value) {
    return String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.includes('?') ? '&' : '?') + 'width=' + width;
  }

  // VC 04.10.2026: Sachliche Zeile „Passt dazu“ – echter Preis, Knopf „+ Hinzufügen“, keine 0-Menge
  function createRecommendationHTML(product, cartVariantIds = []) {
    // Get all available variants that are NOT in cart
    const availableVariants = product.variants?.filter(v => v.available && !cartVariantIds.includes(v.id));
    if (!availableVariants || availableVariants.length === 0) return ''; // No available variant found that's not in cart

    // Randomly select one variant from available variants
    const variant = availableVariants[Math.floor(Math.random() * availableVariants.length)];
    const hasVariantTitle = variant.title && variant.title !== 'Default Title';
    const image = variant.featured_image?.src || product.featured_image || product.images?.[0] || '';
    const url = `/products/${product.handle}${hasVariantTitle ? `?variant=${variant.id}` : ''}`;

    let unitPrice = '';
    if (variant.unit_price && variant.unit_price_measurement) {
      const m = variant.unit_price_measurement;
      const ref = `${m.reference_value && m.reference_value !== 1 ? m.reference_value + ' ' : ''}${m.reference_unit || ''}`;
      unitPrice = `<span class="vc-rec__unit-price">(${formatMoney(variant.unit_price)} / ${escapeHTML(ref)})</span>`;
    }

    return `
      <div class="vc-rec" data-product-id="${product.id}" data-variant-id="${variant.id}">
        <p class="vc-rec__heading">Weitere Artikel</p>
        <div class="vc-rec__row">
          ${image ? `
            <a href="${url}" class="vc-rec__media" tabindex="-1" aria-hidden="true">
              <img src="${escapeHTML(sizedImage(image, 160))}" alt="" width="64" height="64" loading="lazy">
            </a>
          ` : ''}
          <div class="vc-rec__info">
            <a href="${url}" class="vc-rec__title">${escapeHTML(product.title)}</a>
            ${hasVariantTitle ? `<span class="vc-rec__variant">${escapeHTML(variant.title)}</span>` : ''}
            <span class="vc-rec__price">${formatMoney(variant.price)}${unitPrice}</span>
          </div>
          <button class="vc-rec__add" type="button" onclick="CartRecommendations.addToCartFromButton(this)"
                  aria-label="${escapeHTML(product.title + (hasVariantTitle ? ' – ' + variant.title : ''))} hinzufügen">+ Hinzufügen</button>
        </div>
      </div>
    `;
  }

  function updateQuantity(button, delta) {
    const input = button.parentElement.querySelector('input[type="number"]');
    const currentValue = parseInt(input.value, 10) || 0;
    const newValue = Math.max(0, currentValue + delta);

    input.value = newValue;
    updatePrice(input);

    // Show/hide add to cart button and reload button based on quantity
    const controls = button.closest('.vc-cart-item__controls');
    const addToCartBtn = controls.querySelector('.vc-rec-add-to-cart');
    const reloadBtn = controls.querySelector('.vc-rec-reload');

    if (newValue >= 1) {
      if (addToCartBtn) addToCartBtn.classList.remove('hidden');
      if (reloadBtn) reloadBtn.classList.add('hidden');
    } else {
      if (addToCartBtn) addToCartBtn.classList.add('hidden');
      if (reloadBtn) reloadBtn.classList.remove('hidden');
    }
  }

  function updatePrice(input) {
    const recItem = input.closest('.vc-cart-item--recommendation');
    const price = parseFloat(recItem.getAttribute('data-price'));
    const quantity = parseInt(input.value, 10) || 0;
    const total = price * quantity;
    const totalFormatted = `${total.toFixed(2).replace('.', ',')} €`;

    const totalPriceDiv = recItem.querySelector('.vc-rec-total-price');
    if (totalPriceDiv) {
      totalPriceDiv.textContent = totalFormatted;
    }
  }

  function addToCartFromButton(button) {
    const recItem = button.closest('[data-variant-id]');
    if (!recItem || button.disabled) return;

    addToCart(recItem.getAttribute('data-variant-id'), 1, button);
  }

  // VC 04.10.2026: Hinzufügen über Horizon-Section-Rendering (Artikel, Summe und Zähler aktualisieren sich selbst)
  async function addToCart(variantId, quantity, triggerElement) {
    if (triggerElement) {
      triggerElement.disabled = true;
      triggerElement.classList.add('is-loading');
    }

    try {
      const root = window.Shopify?.routes?.root || '/';
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((component) => component.dataset.sectionId)
        .filter(Boolean);

      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: quantity }],
          sections: sectionIds.join(',')
        })
      });
      const added = await response.json();
      if (!response.ok || added.status) throw new Error(added.description || added.message || 'Hinzufügen fehlgeschlagen');

      // Artikel liegt im Warenkorb – Anzeige immer aktualisieren, auch wenn cart.js scheitert
      let cart = null;
      try {
        cart = await (await fetch(root + 'cart.js')).json();
      } catch (e) { /* Ersatzwert unten */ }
      const bubble = document.querySelector('.cart-bubble__text-count');
      const itemCount = cart && typeof cart.item_count === 'number'
        ? cart.item_count
        : (parseInt(bubble?.textContent, 10) || 0) + quantity;

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart || {},
          sourceId: 'vc-cart-recommendation',
          data: {
            source: 'vc-cart-recommendation',
            itemCount: itemCount,
            variantId: Number(variantId),
            sections: added.sections
          }
        }
      }));
    } catch (error) {
      console.error('Add to cart error:', error);
      if (triggerElement) {
        triggerElement.classList.remove('is-loading');
        triggerElement.disabled = false;
        triggerElement.textContent = 'Erneut versuchen';
        triggerElement.setAttribute('aria-label', 'Erneut versuchen');
      }
    }
  }

  // Keep old function name for compatibility
  async function handleQuantityChange(input, variantId) {
    updatePrice(input);
  }

  async function loadRecommendations() {
    const container = document.getElementById('vc-cart-recommendations-container');
    if (!container) return;

    // Get current cart items from DOM (exclude recommendations)
    const cartItems = document.querySelectorAll('.vc-cart-item[data-product-id]:not(.vc-cart-item--recommendation)');
    if (!cartItems || cartItems.length === 0) return;

    // Extract product IDs, variant IDs with quantities and check for Akku products
    const cartProductMap = new Map(); // productId -> { id, quantity, title }
    const cartProductIds = [];
    const cartVariantIds = []; // Track variant IDs in cart
    let hasAkkuInCart = false;

    cartItems.forEach(item => {
      const productId = item.getAttribute('data-product-id');
      if (!productId) return;

      const id = parseInt(productId);

      // Get variant ID from data-key (format: "variantId:..." or just key)
      const dataKey = item.getAttribute('data-key');
      if (dataKey) {
        // Extract variant ID from key - format varies, but first part is usually variant ID
        const variantId = parseInt(dataKey.split(':')[0]);
        if (variantId && !cartVariantIds.includes(variantId)) {
          cartVariantIds.push(variantId);
        }
      }

      // Get quantity from quantity selector
      const quantityInput = item.querySelector('.vc-cart-quantity input[type="number"]');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 0 : 0;

      // Get product title
      const titleElement = item.querySelector('.vc-cart-item__title');
      const title = titleElement ? titleElement.textContent.trim() : '';

      // Check if product title contains "Akku"
      if (title.toLowerCase().includes('akku')) {
        hasAkkuInCart = true;
      }

      // Store product info
      if (!cartProductMap.has(id)) {
        cartProductMap.set(id, { id, quantity, title });
        cartProductIds.push(id);
      }
    });

    if (cartProductIds.length === 0) return;

    // Sort products by quantity (highest first) and take top 3
    const topProducts = Array.from(cartProductMap.values())
      .sort((a, b) => b.quantity - a.quantity)
      .slice(0, 3);

    // Randomize the order of top products for variety
    const shuffledTopProducts = topProducts.sort(() => Math.random() - 0.5);

    // Try to fetch recommendations from each top product until we find valid ones
    let filtered = [];
    let sourceProductIsNikotinfrei = false;

    for (const product of shuffledTopProducts) {
      const recommendations = await fetchRecommendations(product.id, 10);
      if (!recommendations || recommendations.length === 0) continue;

      // Check if source product is nikotinfrei
      sourceProductIsNikotinfrei = product.title.toLowerCase().includes('nikotinfrei');

      // Filter out products/variants already in cart
      filtered = recommendations.filter(rec => {
        // If product has no variants (or only default), check if product is in cart
        if (!rec.variants || rec.variants.length <= 1) {
          return !cartProductIds.includes(rec.id);
        }

        // If product has variants, check if at least one variant is NOT in cart
        const hasAvailableVariant = rec.variants.some(variant => {
          return variant.available && !cartVariantIds.includes(variant.id);
        });

        return hasAvailableVariant;
      });

      // If cart contains Akku product, filter out all Akku recommendations
      if (hasAkkuInCart) {
        filtered = filtered.filter(rec => !rec.title.toLowerCase().includes('akku'));
      }

      // If we found valid recommendations, stop searching
      if (filtered.length > 0) break;
    }

    if (filtered.length === 0) return;

    // Filter out products with no available variants
    filtered = filtered.filter(product => {
      return product.variants && product.variants.some(v => v.available);
    });

    if (filtered.length === 0) return;

    // Prioritize recommendations based on nikotinfrei preference
    let candidateRecs;
    if (sourceProductIsNikotinfrei) {
      // Source is nikotinfrei → prefer nikotinfrei recommendations
      const nikotinfreiRecs = filtered.filter(rec => rec.title.toLowerCase().includes('nikotinfrei'));
      candidateRecs = nikotinfreiRecs.length > 0 ? nikotinfreiRecs : filtered;
    } else {
      // Source is NOT nikotinfrei → prefer non-nikotinfrei recommendations
      const nonNikotinfreiRecs = filtered.filter(rec => !rec.title.toLowerCase().includes('nikotinfrei'));
      candidateRecs = nonNikotinfreiRecs.length > 0 ? nonNikotinfreiRecs : filtered;
    }

    // Exclude last recommended product if there are other options
    if (lastRecommendedProductId && candidateRecs.length > 1) {
      const withoutLast = candidateRecs.filter(rec => rec.id !== lastRecommendedProductId);
      if (withoutLast.length > 0) {
        candidateRecs = withoutLast;
      }
    }

    // Pick randomly from top 3 for variety
    const topThree = candidateRecs.slice(0, 3);
    const firstRec = topThree[Math.floor(Math.random() * topThree.length)];

    // Remember this product for next time
    lastRecommendedProductId = firstRec.id;

    container.innerHTML = `
      <div class="vc-cart-recommendations">
        ${createRecommendationHTML(firstRec, cartVariantIds)}
      </div>
    `;
  }

  function init() {
    // Load recommendations when cart drawer opens
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const cartDrawer = mutation.target;
          if (cartDrawer.classList.contains('cart-drawer__dialog') && cartDrawer.hasAttribute('open')) {
            setTimeout(loadRecommendations, 100);
          }
        }
      }
    });

    // Observe cart drawer dialog
    const cartDrawer = document.querySelector('.cart-drawer__dialog');
    if (cartDrawer) {
      observer.observe(cartDrawer, { attributes: true });
    }

    // Also load on page load if cart drawer is already open or on /cart page
    const isCartPage = window.location.pathname.includes('/cart');
    if ((cartDrawer && cartDrawer.hasAttribute('open')) || isCartPage) {
      loadRecommendations();
    }

    // Reload recommendations when cart updates
    document.addEventListener('cart:update', () => {
      // Skip if recommendation is being updated
      if (isUpdatingRecommendation) return;

      // Wait for cart to update, then reload recommendations if drawer is open or on /cart page
      setTimeout(() => {
        const cartDrawer = document.querySelector('.cart-drawer__dialog');
        const isCartPage = window.location.pathname.includes('/cart');
        if ((cartDrawer && cartDrawer.hasAttribute('open')) || isCartPage) {
          loadRecommendations();
        }
      }, 300);
    });

    // Also listen to cart:refresh for recommendation add-to-cart
    document.documentElement.addEventListener('cart:refresh', () => {
      setTimeout(() => {
        const cartDrawer = document.querySelector('.cart-drawer__dialog');
        const isCartPage = window.location.pathname.includes('/cart');
        if ((cartDrawer && cartDrawer.hasAttribute('open')) || isCartPage) {
          loadRecommendations();
        }
      }, 300);
    });
  }

  function reloadRecommendations() {
    loadRecommendations();
  }

  return {
    init,
    handleQuantityChange,
    updateQuantity,
    updatePrice,
    addToCartFromButton,
    reloadRecommendations
  };
})();

// Expose to global scope for inline handlers
window.CartRecommendations = CartRecommendations;


/* ========================================
   4b. ADD-TO-CART TOAST (VC 04.10.2026)
   Dezente Bestätigung statt Einschub: „✓ Produkt – Sorte liegt im Warenkorb · Zum Warenkorb“
   ======================================== */

const AddToCartToast = (() => {
  const HIDE_AFTER = 3000;
  const SOURCES = ['product-form-component', 'sticky-buy-bar'];
  let toast = null;
  let hideTimer = null;
  let sequence = 0;

  const root = () => window.Shopify?.routes?.root || '/';
  const supportsPopover = typeof HTMLElement !== 'undefined' && 'popover' in HTMLElement.prototype;

  function escapeHTML(value) {
    return String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  }

  function build() {
    toast = document.createElement('div');
    toast.id = 'vc-atc-toast';
    toast.className = 'vc-atc-toast';
    toast.setAttribute('role', 'status');
    if (supportsPopover) toast.setAttribute('popover', 'manual');
    toast.innerHTML = `
      <span class="vc-atc-toast__check" aria-hidden="true">✓</span>
      <span class="vc-atc-toast__text"></span>
      <a class="vc-atc-toast__link" href="${root()}cart">Zum Warenkorb</a>
    `;
    toast.querySelector('.vc-atc-toast__link').addEventListener('click', openCart);
    toast.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') clearTimeout(hideTimer); });
    toast.addEventListener('pointerleave', (event) => { if (event.pointerType === 'mouse') scheduleHide(); });
    toast.addEventListener('focusin', () => clearTimeout(hideTimer));
    toast.addEventListener('focusout', scheduleHide);
    document.body.appendChild(toast);

    // Schließt der Dialog, in dem der Hinweis liegt, kommt er zurück in den body
    document.addEventListener('close', (event) => {
      if (event.target instanceof HTMLDialogElement && event.target.contains(toast)) {
        if (supportsPopover && isOpen()) toast.hidePopover();
        toast.classList.remove('is-visible');
        document.body.appendChild(toast);
      }
    }, true);
  }

  function openModalDialog() {
    // Nur Theme-Dialoge (Schnellansicht u. a.); die kurzlebige Flug-Animation des Themes ist ein Dialog ohne Klasse
    return Array.from(document.querySelectorAll('dialog.dialog-modal[open]')).find((dialog) => {
      if (dialog.classList.contains('dialog-closing')) return false;
      try { return dialog.matches(':modal'); } catch (e) { return false; }
    });
  }

  function isOpen() {
    if (!toast) return false;
    if (!supportsPopover) return toast.classList.contains('is-visible');
    try { return toast.matches(':popover-open'); } catch (e) { return false; }
  }

  function position() {
    const header = document.querySelector('#header-component, header-component');
    let top = 12;
    if (header) {
      const rect = header.getBoundingClientRect();
      if (rect.bottom > 0) top = Math.max(12, Math.round(rect.bottom) + 8);
    }
    toast.style.top = top + 'px';
  }

  function show(html) {
    if (!toast) build();

    // In einem offenen Schnellansicht-Dialog muss der Hinweis im Dialog liegen, sonst ist er inert
    const host = openModalDialog() || document.body;
    if (toast.parentElement !== host) {
      if (supportsPopover && isOpen()) toast.hidePopover();
      host.appendChild(toast);
    }

    const textElement = toast.querySelector('.vc-atc-toast__text');
    textElement.textContent = '';
    position();

    if (supportsPopover) {
      try {
        if (isOpen()) toast.hidePopover();
        toast.showPopover();
      } catch (e) { /* Popover nicht möglich: normal anzeigen */ }
    }
    toast.classList.remove('is-visible');
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    requestAnimationFrame(() => { textElement.innerHTML = html; });
    scheduleHide();
  }

  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, HIDE_AFTER);
  }

  function hide() {
    if (!toast) return;
    clearTimeout(hideTimer);
    toast.classList.remove('is-visible');
    setTimeout(() => {
      if (!toast.classList.contains('is-visible') && supportsPopover && isOpen()) {
        try { toast.hidePopover(); } catch (e) { /* bereits zu */ }
      }
    }, 250);
  }

  function openCart(event) {
    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer || typeof drawer.open !== 'function') return; // ohne Einschub: normaler Link auf /cart

    event.preventDefault();
    hide();

    const quickAdd = document.querySelector('quick-add-dialog');
    if (quickAdd && openModalDialog() && quickAdd.contains(openModalDialog()) && typeof quickAdd.closeDialog === 'function') {
      Promise.resolve(quickAdd.closeDialog()).then(() => drawer.open());
    } else {
      drawer.open();
    }
  }

  async function onCartUpdate(event) {
    const detail = event.detail || {};
    const data = detail.data || {};
    if (data.didError || !SOURCES.includes(data.source)) return;
    if (document.querySelector('.cart-drawer__dialog[open]')) return; // Einschub ist offen: Änderung ist dort sichtbar

    const variantId = data.source === 'product-form-component' ? detail.sourceId : data.variantId;
    const current = ++sequence;
    let label = 'Artikel';

    try {
      const cart = detail.resource?.items ? detail.resource : await (await fetch(root() + 'cart.js')).json();
      const item = cart.items.find((line) => String(line.variant_id) === String(variantId));
      if (item) {
        const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        label = `<strong>${escapeHTML(item.product_title)}${variantTitle ? ', ' + escapeHTML(variantTitle) : ''}</strong>`;
      }
    } catch (error) {
      /* Name nicht ermittelbar: neutraler Text */
    }

    if (current !== sequence) return; // schneller Mehrfachklick: nur der letzte zählt
    show(`${label} liegt im Warenkorb`);
  }

  function init() {
    window.VCAddToCartToast = true;
    document.addEventListener('cart:update', onCartUpdate);
  }

  return { init, show, hide };
})();

window.AddToCartToast = AddToCartToast;

/* ========================================
   5. EOL VARIANT AUTO-SELECTION
   ======================================== */

const EOLVariantSelector = (() => {
  function selectFirstAvailableVariant() {
    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) return;

    // Check if any selected option is EOL-hidden
    const selectedOptions = variantPicker.querySelectorAll('option[selected], input[checked]');
    let hasEOLSelected = false;

    selectedOptions.forEach(option => {
      const parent = option.closest('[data-eol-hidden="true"]') || option.closest('label[data-eol-hidden="true"]');
      if (option.hasAttribute('data-eol-hidden') || parent) {
        hasEOLSelected = true;
      }
    });

    if (!hasEOLSelected) return; // Current selection is fine

    // Find first available (non-EOL-hidden) option for each picker
    const selects = variantPicker.querySelectorAll('select.variant-option__select');
    const radioGroups = variantPicker.querySelectorAll('fieldset.variant-option--buttons');

    // Handle dropdowns
    selects.forEach(select => {
      const firstAvailable = select.querySelector('option:not([data-eol-hidden="true"])');
      if (firstAvailable && !firstAvailable.selected) {
        firstAvailable.selected = true;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Handle radio buttons (buttons/swatches)
    radioGroups.forEach(fieldset => {
      const firstAvailableLabel = fieldset.querySelector('label:not([data-eol-hidden="true"])');
      if (firstAvailableLabel) {
        const radio = firstAvailableLabel.querySelector('input[type="radio"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  function init() {
    // Run on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', selectFirstAvailableVariant);
    } else {
      selectFirstAvailableVariant();
    }

    // Also run when variant picker is updated (e.g., after AJAX)
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.target.matches('variant-picker')) {
          selectFirstAvailableVariant();
        }
      }
    });

    const variantPicker = document.querySelector('variant-picker');
    if (variantPicker) {
      observer.observe(variantPicker, { childList: true, subtree: true });
    }
  }

  return { init };
})();


/* ========================================
   6. PRODUCT PAGE AUTO-SCROLL (MOBILE ONLY)
   ======================================== */

const ProductPageAutoScroll = (() => {
  function init() {
    // Only on mobile (< 750px)
    if (window.innerWidth >= 750) {
      console.log('[ProductPageAutoScroll] Desktop detected, skipping');
      return;
    }

    // kn-1028 (28.10.2026): Scrollen erst, wenn die Altersabfrage bestaetigt ist (vorher sperrt sie den Bildlauf
    // und der Sprung verpufft -> Erstbesucher sah weder Preis noch Kaufknopf)
    const doScroll = () => {
      // kn-1028: wer schon selbst scrollt, wird nicht zurueckgerissen
      if (window.scrollY > 100) return;

      // Blur any focused element to prevent autofocus interference
      if (document.activeElement && document.activeElement !== document.body) {
        document.activeElement.blur();
      }

      const addToCartButtons = document.querySelector('.product-form-buttons');
      if (!addToCartButtons) {
        console.log('[ProductPageAutoScroll] .product-form-buttons not found - not a product page');
        return;
      }

      console.log('[ProductPageAutoScroll] Element found, preparing scroll');

      // Use native browser smooth scroll (most reliable on mobile)
      const originalScrollBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'smooth';

      // Scroll element into view at bottom of viewport
      // kn-1028: liegt unten noch der Cookie-Banner, Knopf mittig statt unten (sonst verdeckt)
      const cookieBanner = document.querySelector('.vc-cookie-banner');
      const bannerVisible = !!(cookieBanner && cookieBanner.getClientRects().length && getComputedStyle(cookieBanner).visibility !== 'hidden' && cookieBanner.getBoundingClientRect().height > 0);
      addToCartButtons.scrollIntoView({
        behavior: 'smooth',
        block: bannerVisible ? 'center' : 'end',
        inline: 'nearest'
      });

      // Reset scroll behavior after animation completes
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = originalScrollBehavior;
      }, 2000);
    };

    setTimeout(() => {
      if (document.documentElement.classList.contains('vc-ag-lock')) {
        document.addEventListener('vc:agegate-ok', () => setTimeout(doScroll, 400), { once: true });
      } else {
        doScroll();
      }
    }, 2000);
  }

  return { init };
})();


/* ========================================
   7. INITIALIZATION
   ======================================== */

function init() {
  AddToCartToast.init();
  CartTooltip.init();
  ModalCustomization.initObserver();
  CollectionRowGradients.init();
  CartRecommendations.init();
  EOLVariantSelector.init();
  ProductPageAutoScroll.init();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
